import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './app-header.component';

@Component({
  selector: 'vt-shell',
  imports: [RouterOutlet, AppHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<vt-app-header /><main class="main"><router-outlet /></main>',
  styles: '.main { max-width: 1320px; margin: 0 auto; padding: 40px 28px 80px; } @media (max-width: 700px) { .main { padding: 24px 16px 64px; } }',
})
export class ShellComponent {}
